// extracted by mini-css-extract-plugin
export var addButton = "_jq-0";
export var border = "_jq-8";
export var check = "_jq-h";
export var danger = "_jq-6";
export var dropdownContainer = "_jq-1";
export var editModalBody = "_jq-j";
export var footerContainer = "_jq-i";
export var fullWidth = "_jq-a";
export var hide = "_jq-9";
export var icon = "_jq-3";
export var input = "_jq-7";
export var inputFlex = "_jq-b";
export var inputWrapper = "_jq-c";
export var manualFocus = "_jq-5";
export var optionButton = "_jq-4";
export var pillWrapper = "_jq-e";
export var pointer = "_jq-2";
export var showOverflow = "_jq-f";
export var tagsFlex = "_jq-d";
export var xButton = "_jq-g";